import React, { FC, PropsWithChildren, useEffect, useRef } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { resetStoreCallbacks } from './consts/resetStoreCallbacks'

// хок проверяет маршруты и при уходе с маршрута вызывает очищающие колбэки
const StoreConfigureProvider: FC<PropsWithChildren> = ({ children }) => {
  const { pathname } = useLocation()
  const prevPathNameRef = useRef<string | null>(null)

  useEffect(() => {
    if (prevPathNameRef.current) {
      const resetKey = Object.keys(resetStoreCallbacks).find((key) =>
        matchPath({ path: key }, prevPathNameRef.current as string)
      )

      if (
        resetKey &&
        !resetStoreCallbacks[resetKey].routes.some((route) =>
          matchPath({ path: route }, pathname)
        )
      ) {
        resetStoreCallbacks[resetKey].resetCallbacks.forEach((callback) => {
          callback()
        })

        if (
          resetStoreCallbacks[resetKey]?.conditionRoutes &&
          !resetStoreCallbacks[resetKey].conditionRoutes.some((route) =>
            matchPath({ path: route }, pathname)
          )
        ) {
          resetStoreCallbacks[resetKey]?.conditionCallbacks?.forEach(
            (callback) => {
              callback()
            }
          )
        }
      }
    }

    prevPathNameRef.current = pathname
  }, [pathname])

  return <>{children}</>
}

export default observer(StoreConfigureProvider)
